module.exports = __webpack_public_path__ + "static/f8cc9d9b80052218678df0338e76d23b76a763e0f412c5a733558973f06e9478-be98ffacbb12968c795e2eb36d4c7393.png";